// Tiny pub/sub so anything (axios interceptors, a manual async action) can
// report in-flight work to the global loader without threading React
// context through every page. GlobalLoader is the only subscriber today.
let pending = 0;
const listeners = new Set();

const notify = () => listeners.forEach(listener => listener(pending));

export const startLoading = () => {
    pending += 1;
    notify();
};

export const stopLoading = () => {
    pending = Math.max(0, pending - 1);
    notify();
};

export const subscribe = listener => {
    listeners.add(listener);
    listener(pending);
    return () => listeners.delete(listener);
};
